export function percentToDecimal(percent) {
  if (!percent) {
    return 0;
  }
  return 1 + (percent / 100)
}

export function addVAT(value, vat) {
  return value * percentToDecimal(vat);
}

export function calculateVAT(value, vat) {
  const vatDecimal = percentToDecimal(vat);
  return value - (value / vatDecimal);
}

export function calculateIncreasedAmortizationAmount(acquisitionPrice, vat, tradeInIncVAT) {
  return (calculateVAT(addVAT(acquisitionPrice, vat)) - calculateVAT(addVAT(tradeInIncVAT, vat)));
}

export function calculateAmortizationAmount(acquisitionPrice, vat, tradeInIncVAT, periodicity, term, creditAmount) {
  const multiplier = periodicity === 'month' ? 1 : 3;
  if (creditAmount) {
    return ((creditAmount - calculateIncreasedAmortizationAmount(acquisitionPrice, vat, tradeInIncVAT)) / term) * multiplier;
  }
  return 0;
}

export default {
  addVAT,
  percentToDecimal,
  calculateAmortizationAmount,
  calculateIncreasedAmortizationAmount,
  calculateVAT,
}
